import React from 'react';
import PropTypes from 'prop-types';
import PartnerBurdenPrice from './PartnerBurdenPrice';
import PartnerBurdenDiscount from './PartnerBurdenDiscount';

/**
 * 파트너 쿠폰 판매가 및 할인가
 */
function PartnerBurdenText({
  price,
  maxAmount,
  discountAmount,
  discountPercent,
  couponType,
  isSkim,
}) {
  return (
    <span className="partner_burden_text">
      <PartnerBurdenPrice isSkim={isSkim} price={price} />
      <PartnerBurdenDiscount
        couponType={couponType}
        discountAmount={discountAmount}
        discountPercent={discountPercent}
        maxAmount={maxAmount}
      />
    </span>
  );
}

PartnerBurdenText.propTypes = {
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxAmount: PropTypes.number,
  discountAmount: PropTypes.number,
  discountPercent: PropTypes.number,
  couponType: PropTypes.string,
  isSkim: PropTypes.bool,
};

export default PartnerBurdenText;
